export const route = (pageContext) => {
    const { urlPathname } = pageContext
    
    // Extract route parameters for all routes
    // For root path, wildcard is empty
    if (urlPathname === '/') {
        return { match: true, routeParams: { '*': '' } }
    }
    
    // For any other path, extract everything after the first slash
    const wildcard = urlPathname.slice(1) // Remove leading slash
    return { match: true, routeParams: { '*': wildcard } }
}